import { AccessPointType_enum, usegetAccessPointRolesQuery } from '../../../graphql/hasura/generated';

import { getApplicableRolesByAccessPoint } from './getApplicableRolesByAccessPoint';

interface IUseAccessPointRolesQuery {
  accessPointId: string;
  type: AccessPointType_enum;
  skip?: boolean;
}

export function useAccessPointRolesQuery(args: IUseAccessPointRolesQuery) {
  const { accessPointId, type, skip } = args;

  const { data, loading, refetch } = usegetAccessPointRolesQuery({
    skip,
    variables: {
      accessPointId,
      roleExp: getApplicableRolesByAccessPoint(accessPointId, type),
    },
  });

  const accessPointRoles = data?.accessPointRoles || [];
  const roles = data?.roles || [];

  return { accessPointRoles, roles, loading, refetch };
}
